import { createRequestActions } from 'actions'

export const allNews = createRequestActions({
  type: 'ALL_NEWS',
  url: '/buildings/news/all'
})



// WEBPACK FOOTER //
// ./src/actions/news.js